import { ButtonHash, StyledButton, StyledSpan } from "./SectionButton.styles";
import React from "react";
import PropTypes from "prop-types";
import { TEAM_NAME } from "../../../utils/info";

const SectionButton = ({ text, color, section, backgroundColor, style }) => {
    return (
        <StyledButton
            to={section === "start" ? "/" : "/" + section}
            style={style}
            color={color}
            bg={backgroundColor}
        >
            {text}
            <ButtonHash>
                {"#" + section.toUpperCase()}
                <StyledSpan>{` ${TEAM_NAME}`}</StyledSpan>
            </ButtonHash>
        </StyledButton>
    );
};

SectionButton.propTypes = {
    text: PropTypes.string.isRequired,
    section: PropTypes.string.isRequired,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
};

export default SectionButton;
